var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('annotations-container',{attrs:{"annotatable-id":_vm.player.id ? _vm.player.id : null,"annotations":_vm.player.annotations,"annotatable-object":_vm.player,"annotation-type":'App\\Player'}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }